/** Página de login para onde o pré-chat manda o cliente. */
export const WEBCHAT_LOGIN_PATH = '/login';

/**
 * Prazo para o login pedido pelo pré-chat abrir o chat na volta. Depois
 * dele, um login qualquer na mesma aba não abre o chat sozinho.
 */
export const WEBCHAT_OPEN_AFTER_LOGIN_TTL_MS = 10 * 60 * 1000;
